import { render } from "./FormRecord.vue?vue&type=template&id=52840df4&ts=true"
import script from "./FormRecord.vue?vue&type=script&lang=ts"
export * from "./FormRecord.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__